module.exports = __webpack_public_path__ + "media/images/edion/en/popular-f30e11df360a08f9a3ce0c6dd07668c9.png";